export const getScheduledDeliveryTimeSource = (
  deliverWithinStoreHours: boolean,
  storeHoursConfirmed: boolean,
): string | undefined => {
  if (deliverWithinStoreHours && storeHoursConfirmed) {
    return 'STORE_HOURS';
  }
  return 'DELIVERY_WINDOW';
};

export const MANAGE_LOCATION_ID_PARAM = 'manageLocationId';
export const MANAGE_WAREHOUSE_ID_PARAM = 'manageWarehouseId';

export type ManageLocationsHandoff = {
  isPresent: boolean;
  isValid: boolean;
  locationIds: string[];
  warehouseId?: string;
};

const normalizeId = (value: string | null): string | undefined => {
  const normalized = value?.trim();
  return normalized ? normalized : undefined;
};

export const buildManageLocationsUrl = ({
  locationIds,
  warehouseId,
}: {
  locationIds: string[];
  warehouseId: string;
}): string => {
  const params = new URLSearchParams();
  const normalizedWarehouseId = normalizeId(warehouseId);

  if (normalizedWarehouseId) {
    params.set(MANAGE_WAREHOUSE_ID_PARAM, normalizedWarehouseId);
  }
  Array.from(
    new Set(locationIds.map((locationId) => normalizeId(locationId))),
  ).forEach((locationId) => {
    if (locationId) params.append(MANAGE_LOCATION_ID_PARAM, locationId);
  });

  const query = params.toString();
  return query ? `/locations?${query}` : '/locations';
};

export const readManageLocationsHandoff = (
  searchParams: URLSearchParams,
): ManageLocationsHandoff => {
  const isPresent =
    searchParams.has(MANAGE_WAREHOUSE_ID_PARAM) ||
    searchParams.has(MANAGE_LOCATION_ID_PARAM);
  const warehouseId = normalizeId(searchParams.get(MANAGE_WAREHOUSE_ID_PARAM));
  const locationIds = Array.from(
    new Set(
      searchParams
        .getAll(MANAGE_LOCATION_ID_PARAM)
        .map(normalizeId)
        .filter((locationId): locationId is string => Boolean(locationId)),
    ),
  );

  return {
    isPresent,
    isValid: Boolean(warehouseId && locationIds.length > 0),
    locationIds,
    warehouseId,
  };
};

export const removeManageLocationsHandoff = (
  searchParams: URLSearchParams,
): URLSearchParams => {
  const next = new URLSearchParams(searchParams);
  next.delete(MANAGE_LOCATION_ID_PARAM);
  next.delete(MANAGE_WAREHOUSE_ID_PARAM);
  return next;
};
